import React, {Fragment} from 'react';
import Overlay from 'Components/Overlay';
const CancelLOiPopUp = (props)=>(

      <Fragment>
        <Overlay>
        <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                    {props.text}
                </div>

                 <div>
                <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                           {props.name}
                        </div>
                        <div className="mb-10 tCenter header-medium-color fSemibold fs-18 mt-10">
                          <textarea 
                                style={{ width: '90%',  height: '50px' }}
                                name="loiCancelRemark"
                                placeholder="Loi Cancel Remark"
                                value={props.loiCancelRemark}
                                onChange={(e) => props.onChangeLoiCancelRemarks(e)}
                            />
                            </div>
                            </div>

                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                <button className={(!props.loiCancelRemark)? 'ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30  inputDisabled' :'ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30'} disabled={!props.loiCancelRemark} onClick={props.onConfirm}>Confirm</button>
                </div>
            </div>    

        </Overlay> 
    </Fragment>
    );
    export default CancelLOiPopUp;